// extracted by mini-css-extract-plugin
export default {"lds-hourglass":"Loader_lds-hourglass__KkgYw"};